import { Box, Grid, Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import { ContaBancariaSomenteLeitura } from 'src/api/recebedor-pendencia-bacen'
import formatarCNPJ from 'src/core/formatacoes/formatarCNPJ'
import formatarCPF from 'src/core/formatacoes/formatarCPF'

const useStyles = makeStyles(theme => ({
  bloco: {
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing(2, 3),
    marginBottom: theme.spacing(3)
  },
  titulo: {
    fontSize: 20,
    fontWeight: 500,
    color: '#455890',
    marginBottom: theme.spacing(0.5)
  },
  rotulo: {
    color: theme.palette.text.secondary,
    fontSize: 12
  },
  valor: {
    fontWeight: 500,
    wordBreak: 'break-word'
  }
}))

type Props = {
  conta: ContaBancariaSomenteLeitura
}

function mascararCpfCnpj(valor?: string) {
  if (!valor) return '—'
  const digitos = valor.replace(/\D/g, '')
  if (digitos.length === 11) return formatarCPF(digitos) || valor
  if (digitos.length === 14) return formatarCNPJ(digitos) || valor
  return valor
}

function ItemLeitura({ rotulo, valor }: { rotulo: string; valor: string }) {
  const classes = useStyles()
  return (
    <Box mb={1}>
      <Typography className={classes.rotulo} component="dt">
        {rotulo}
      </Typography>
      <Typography className={classes.valor} component="dd">
        {valor || '—'}
      </Typography>
    </Box>
  )
}

export default function ContaBancariaLeitura({ conta }: Props) {
  const classes = useStyles()
  const documento = mascararCpfCnpj(conta.cpfCnpj)
  const rotuloDocumento =
    (conta.cpfCnpj || '').replace(/\D/g, '').length > 11
      ? 'CNPJ do titular'
      : 'CPF do titular'

  return (
    <Box
      className={classes.bloco}
      component="section"
      aria-label="Dados da conta bancária para conferência"
    >
      <Typography className={classes.titulo} component="h3">
        Dados Bancários
      </Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        Conta bancária (somente leitura). Confira se a conta abaixo é a
        correta. Banco, agência, conta e titularidade não podem ser alterados
        nesta tela.
      </Typography>
      <Grid container spacing={2} component="dl">
        <Grid item xs={12} sm={6} md={4}>
          <ItemLeitura rotulo={rotuloDocumento} valor={documento} />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ItemLeitura
            rotulo="Banco"
            valor={
              conta.nomeBanco
                ? `${conta.codigoBanco} — ${conta.nomeBanco}`
                : conta.codigoBanco
            }
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <ItemLeitura rotulo="Tipo de conta" valor={conta.tipoConta} />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <ItemLeitura rotulo="Agência" valor={conta.agencia} />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <ItemLeitura rotulo="Conta" valor={conta.conta} />
        </Grid>
      </Grid>
    </Box>
  )
}
